/* @flow strict */

/* eslint-disable camelcase */

import * as React from 'react';
import FooterTotal from './footer/footer';
import { _visibleTickets, _visibleDonations, ticketsState, _hiddenTickets } from '/client/src/utils/buyService';
import Loader from '/client/src/components/Loader';
import Case2 from '/client/src/pages/Events/detail/design/ticketSections/case2';
import _ from 'lodash';
import { GET } from '/client/src/api';

import StepsToggler from './stepToggler';
import EventDetail from './eventDetail';
import { StepTickets } from './steps/stepTickets';
import { StepPurchase } from './steps/stepPurchase';
import { StepPayment } from './steps/stepPayment';
import { StepRegistration } from './steps/stepRegistration';
import { StepDownload } from './steps/stepDownload';
import './checkout.scss';

type EmbedCheckoutType = {
  eventDetail: {
    donations: [],
    discounts: [],
    questions: [],
    tickets: [],
    id: string,
    need_collect_demographic_data: boolean,
    skip_collect_attendee_information: boolean
  },
  handleSetDonatedTotal: () => void,
  handleShowHideDescription: () => void
};

type EmbedCheckoutStateType = {
  visibleTickets: [],
  visibleDonations: [],
  visibleVipTickets: [],
  buyCart: [],
  _ticketsState: null,
  isShowStripe: boolean,
  hiddenTickets: [],
  step: number,
  currentSubtotal: number,
  registrationInfo: {},
  registrationInfoSubmited: boolean
};

export default class EmbedCheckout extends React.Component<EmbedCheckoutType, EmbedCheckoutStateType> {
  constructor(props: EmbedCheckoutType) {
    super(props);

    this.state = {
      visibleTickets: [],
      visibleDonations: [],
      visibleVipTickets: [],
      buyCart: [],
      _ticketsState: null,
      isShowStripe: false,
      hiddenTickets: [],
      step: 1,
      currentSubtotal: 0,
      registrationInfo: {},
      registrationInfoSubmited: false
    };
  }

  handleLoaded = (error: Error, { data }: any) => {
    if (error) {
      console.log(error);
    }

    const _buyCart = [];

    _.forEach(_visibleTickets(this.props.eventDetail, data.result), (t: {}) => {
      if (t.default_ticket_quantity > 0) {
        for (let i = 0; i < t.default_ticket_quantity; i++) {
          _buyCart.push(t);
        }
      }
    });

    this.setState({
      visibleTickets: _visibleTickets(this.props.eventDetail, data.result),
      visibleDonations: _visibleDonations(this.props.eventDetail.donations),
      hiddenTickets: _hiddenTickets(this.props.eventDetail.tickets),
      buyCart: _buyCart,
      _ticketsState: ticketsState(
        _visibleTickets(this.props.eventDetail, data.result),
        this.props.eventDetail.donations,
        this.props.eventDetail
      ),
      visibleVipTickets: []
    }, async () => {
      try {
        const { result } = await GET(`/api/v1/1/statistics/events/${this.props.eventDetail.id}/transaction/donations`);

        const _donations = _.clone(this.state.visibleDonations);

        _.map(result, (item: {donation_id: string, amount: number, amount_refund: number}) => {
          const _exist = _.findIndex(_donations, (_t: {}): {} => _t.id === item.donation_id);

          if (_exist !== -1) {
            _donations[_exist].amount = item.amount - item.amount_refund;
          }
        });

        this.setState({ visibleDonations: _donations });
      } catch (e) {
        console.log(e);
      }
    });
  }

  handleChangeDonation = (item: {}, count: number) => {
    const _buyCart = _.clone(this.state.buyCart);

    const isExist = _.findIndex(_buyCart, (i: {}): void => _.toString(i.id) === _.toString(item.id));

    if (isExist === -1) {
      _buyCart.push(!!count ? { ...item, prefilled_amount: count } : item);
    } else {
      _buyCart[isExist].prefilled_amount = count;
    }

    this.setState({
      buyCart: _buyCart
    });
  }

  handleChangeDonationPrefliedAmount = (id: number, pAmount: string) => {
    const _buyCart = _.clone(this.state.buyCart);

    this.setState({
      buyCart: _.map(_buyCart, (t: { prefilled_amount: string, id: string }): {} => {
        const _t = _.clone(t);

        if (_.toString(_t.id) === _.toString(id)) {
          _t.prefilled_amount = pAmount;
        }

        return _t;
      })
    });
  }

  handleUpdateVT = (visibleTickets: {}) => {
    this.setState({ visibleTickets });
  }

  handleAddToVipTickets = (newTickets: []) => {
    const visibleVipTicketsClone = _.clone(this.state.visibleVipTickets);

    this.setState({
      visibleVipTickets: _.concat(newTickets, visibleVipTicketsClone)
    });
  }

  handleUpdateBuyCart = (buyCart: {}) => {
    this.setState({ buyCart });
  }

  handleAddTicket = (ticket: {order_min_quantity: number, id: string}) => {
    const sameTickets = _.filter(this.state.buyCart, (t: {}): any => _.toString(t.id) === _.toString(ticket.id));
    const addCount = sameTickets < ticket.order_min_quantity ? ticket.order_min_quantity : 1;
    const newData = [];

    for (let i = 0; i < addCount; i++) {
      newData.push(ticket);
    }

    this.setState({
      buyCart: [
        ...this.state.buyCart,
        ...newData
      ]
    });
  }

  handleRemoveTicket = (ticket: {}) => {
    let sameTickets = _.filter(this.state.buyCart, (t: {}): any => _.toString(t.id) === _.toString(ticket.id));

    if (sameTickets.length === ticket.order_min_quantity) {
      sameTickets = [];
    } else {
      sameTickets.shift();
    }

    const otherTickets = _.filter(this.state.buyCart, (t: {}): any => _.toString(t.id) !== _.toString(ticket.id));

    this.setState({
      buyCart: [
        ...otherTickets,
        ...sameTickets
      ]
    });
  }

  handleSetTotal = (currentSubtotal: number) => {
    this.setState({
      currentSubtotal
    });
  }

  nextStep = () => {
    const { step } = this.state;
    const skipRegistration = !this.isRegistrationShow();

    if (step === 4) {
      const isValid = this.validateRegistrationForm();

      if (!isValid) {
        return;
      }
      // this.handleSubmitRegistrationForm(); no action, this is demo checkout
    }

    this.setState({
      step: step === 3 && skipRegistration ? step + 2 : step + 1
    }, (): void => this.props.handleShowHideDescription(this.state.step === 1));
  };

  toggleStep = (step: number) => {
    this.setState({
      step
    }, (): void => this.props.handleShowHideDescription(this.state.step === 1));
  }

  downloadTicket = async () => {
    const orderId = 3333333333;
    const email = 'test@text.com';

    try {
      await GET(`/api/v1/1/orders/${orderId}/print_tickets?customer_email_address=${email}`);
    } catch (e) {
      console.log(e);
    }
  }

  setInitialRegistrationForm = (initForm: {}) => {
    this.setState({
      registrationInfo: initForm
    });
  }

  handleAdditionalInfoChange = (objValue: {}) => {
    this.setState({
      registrationInfo :{
        ...this.state.registrationInfo,
          additionalInfo: {
          ...this.state.registrationInfo.additionalInfo,
          ...objValue
          }
    }
    });
  }

  upsertRegistrationInfo = (array: [], item: {}): [] => {
    const _array = _.clone(array);
    const i = _array.findIndex((_item: {}): number => _item.id === item.id && _item.ticketId === item.ticketId);

    if (i > -1) {
      _array[i] = { ..._array[i], ...item };
    } else _array.push(item);

    return _array;
  };

  upsertTicketQuestions = (array: [], item: {}): [] => {
    const _array = _.clone(array);
    const i = _array.findIndex((_item: {}): number => _item.id === item.id);

    if (i > -1) {
      _array[i] = { ..._array[i], ...item };
    } else _array.push(item);

    return _array;
  };

  handleRegistrationInfoChange = (e: {}, ticketId: string, index: number) => {
    e.persist();
    this.setState((prevState: {}): void => {
      return { registrationInfo: {
        ...prevState.registrationInfo,
        ticketsInfo: this.upsertRegistrationInfo(prevState.registrationInfo.ticketsInfo, {
        id: index + 1,
        [e.target.name]: e.target.value,
        ticketId
      }) }
    };
   });
  };
  handleTicketQuestionChange = (question: {}, ticketId: string, index: number) => {
    this.setState((prevState: {}): void => {
      const prevTicket = prevState.registrationInfo.ticketsInfo.find((el: {id: string, ticketId: string}): [] => (
        el.id === index + 1 && el.ticketId === ticketId
      ));

      return { registrationInfo: {
        ...prevState.registrationInfo,
        ticketsInfo: this.upsertRegistrationInfo(prevState.registrationInfo.ticketsInfo, {
        id: index + 1,
        ticketId,
        questions: this.upsertTicketQuestions(
          [...(prevTicket && prevTicket.questions || [])],
          question
        )
      }) }
    };
   });
  }

  validateRegistrationForm = (): boolean => {
    const { registrationInfo } = this.state;

    let isValid = true;

    this.setState({
      registrationInfoSubmited: true
    });
    registrationInfo.ticketsInfo.forEach((ticket: {}) => {
      Object.values(ticket).map((el: any) => {
         if (!el) {
           isValid = false;
         }
      });
    });

    return isValid;
  }

  validateAttendeeQuestions = (questions: {}): boolean => {
    let isValid = true;

    questions.map((question: {}) => {
      Object.values(question).map((el: any) => {
        if (!el) {
          isValid = false;
        }
      });
  });
  return isValid;
}

  isRegistrationShow = (): boolean => {
    const { eventDetail } = this.props;
    const hasQuestions = !!_.size(eventDetail.questions);

    return hasQuestions || !eventDetail.skip_collect_attendee_information || eventDetail.need_collect_demographic_data;
  }

  render(): React.Element<'div'> {
    const { eventDetail, handleSetDonatedTotal } = this.props;
    const {
      visibleTickets,
      visibleDonations,
      visibleVipTickets,
      _ticketsState,
      isShowStripe,
      hiddenTickets,
      buyCart,
      step,
      currentSubtotal,
      registrationInfo,
      registrationInfoSubmited
    } = this.state;
    const id: string | null = _.get(eventDetail, 'id', null);
    const scheduleId: string | null = _.get(eventDetail, 'schedules[0].id', null);

    const isIssetDiscount = _.some(buyCart, (t: {price_with_discount: number}): [] => t.price_with_discount);

    const isRegistrationShow = this.isRegistrationShow();

    return (
      <div className={`sparxo-checkout sparxo-embeded ${!isShowStripe ? 'step-20' : ''}`}>
        <Loader
          url={`/api/v1/1/events/${id}/tickets?scheduleId=${scheduleId}&paymentMethod=StripeTokenDirect`}
          onLoaded={this.handleLoaded}
        >
          {_ticketsState === -2 &&
            <Case2 />
          }

          {_ticketsState === -1 &&
            <>not started</>
          }

          {_ticketsState === 0 &&
            <>
              <div
                data-bind="attr:{id:scroll_id}"
                className="sparxo-embeded-body"
                id="sparxo_scroll_1000"
              >
                <div className="sparxo-client-view">
                  {step > 1 &&
                    <>
                    <StepsToggler
                      currentStep={step}
                      eventDetail={eventDetail}
                      isRegistrationShow={isRegistrationShow}
                      toggleStep={this.toggleStep}
                    />
                    <EventDetail eventDetail={eventDetail} />
                    </>
                  }
                  <div className={'sparxo-embeded-tickets sparxo-checkout_stepsContainer'}>
                    {step === 1 &&
                      <StepTickets
                        eventDetail={eventDetail}
                        visibleTickets={visibleTickets}
                        visibleVipTickets={visibleVipTickets}
                        visibleDonations={visibleDonations}
                        buyCart={buyCart}
                        hiddenTickets={hiddenTickets}
                        onHandleAddToVipTickets={this.handleAddToVipTickets}
                        onHandleChangeDonationPrefliedAmount={this.handleChangeDonationPrefliedAmount}
                        onHandleAddTicket={this.handleAddTicket}
                        onHandleRemoveTicket={this.handleRemoveTicket}
                        onHandleChangeDonation={this.handleChangeDonation}
                        onHandleSetDonatedTotal={handleSetDonatedTotal}
                      />
                    }
                    {step === 2 &&
                      <StepPurchase
                        eventDetail={eventDetail}
                        buyCart={buyCart}
                        visibleTickets={visibleTickets}
                        onHandleUpdateBuyCart={this.handleUpdateBuyCart}
                        onHandleUpdateVT={this.handleUpdateVT}
                        onHandleSetTotal={this.handleSetTotal}
                      />
                    }
                    {step === 3 &&
                      <StepPayment
                        {...this.props}
                        {...this.state}
                        isIssetDiscount={isIssetDiscount}
                      />
                    }
                     {isRegistrationShow && step === 4 &&
                      <StepRegistration
                        eventDetail={eventDetail}
                        buyCart={buyCart}
                        formSubmited={registrationInfoSubmited}
                        registrationInfo={registrationInfo}
                        setInitialRegistrationForm={this.setInitialRegistrationForm}
                        onAdditionalInfoChange={this.handleAdditionalInfoChange}
                        onRegistrationInfoChange={this.handleRegistrationInfoChange}
                        onTicketQuestionChange={this.handleTicketQuestionChange}
                      />
                    }
                    {step === 5 &&
                      <StepDownload
                        downloadTicket={this.downloadTicket}
                        eventDetail={eventDetail}
                      />
                    }
                  </div>
                </div>
              </div>

              {_ticketsState === 0 && !!_.size(buyCart) && !isShowStripe && step !== 5 &&
                <FooterTotal
                  buyCart={buyCart}
                  eventDetail={eventDetail}
                  isIssetDiscount={isIssetDiscount}
                  isRegistrationShow={isRegistrationShow}
                  handleNextStep={this.nextStep}
                  currentStep={step}
                  currentSubtotal={currentSubtotal}
                />
              }
            </>
          }
        </Loader>
      </div>
    );
  }
}
